var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 103,
    viewBox: "0 0 151 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_85_104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 151,
    height: 103
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.56885V94.0895L42.7603 51.3292L0 8.56885Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49658 0L62.6319 54.1353C69.469 60.9724 81.3931 60.9724 88.2302 54.1353L142.366 0H8.49658Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7633 62.6679C91.0728 68.3644 83.4935 71.5084 75.4314 71.5084C67.3693 71.5084 59.79 68.3644 54.0995 62.6679L51.2935 59.8618L8.56934 102.586H142.293L99.5693 59.8618L96.7633 62.6679Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.102 51.3292L150.862 94.0895V8.56885L108.102 51.3292Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_85_104)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -16,
    width: 199,
    height: 185,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.17fe2ce9519ef5d6d2cda5cbf2174ca5.svg";
export { ForwardRef as ReactComponent };